import { HttpErrorResponse } from '@angular/common/http';
import { FormArray, FormGroup } from '@angular/forms';

export const applyErrorsToForm = (
  errors: HttpErrorResponse['error'],
  form: FormGroup | FormArray,
): void => {
  Object.keys(errors).forEach((key) => {
    const control = form.get(key);
    if (control instanceof FormGroup || control instanceof FormArray) {
      // Recursively handle nested controls
      applyErrorsToForm(errors[key], control);
    } else {
      // Apply errors to the control
      control?.setErrors(errors[key]);
    }
  });
};
